<template>
    <div style="height:100%" class="menue">
        <template v-for="item in getMenu">
            <template v-if="item.status == 1">
                <el-menu-item :index="item.menuUrl?item.menuUrl.substr(item.menuUrl.lastIndexOf('/')):item.menuCode+''" :key="item.menuCode" v-if="!item.children">
                    <i :class="[{icon:true,iconfont:true},item.menuIcon]" style=" font-size:16px;"></i>&nbsp;
                    <span slot="title">{{item.menuName}}</span>
                </el-menu-item>
                <el-submenu :index="item.menuUrl?item.menuUrl.substr(item.menuUrl.lastIndexOf('/')):item.menuCode+''"  v-else :key="item.menuCode">
                    <template slot="title">
                        <i :class="[{icon:true,iconfont:true},item.menuIcon]" style="font-size:16px;"></i>&nbsp;
                        <span :class="{'hmenuCodeden-close':isCollapse}">{{item.menuName}}</span>
                    </template>
                    <common-menu :getMenu="item.children"></common-menu>
                </el-submenu>
            </template>
        </template>
    </div>
</template>
<script>
export default {
    name:'CommonMenu',
    props:{
        getMenu:Array,
        isCollapse:Boolean
    }
}
</script>
<style >
.menue .el-menu-item,.menue .el-submenu__title{
    height:38px !important;
    line-height: 37px !important;
    padding-left: 17px !important;
}
.menue .el-menu--inline .el-menu-item{
    height:33px !important;
    line-height: 31px !important;
    padding-left: 33px !important;
}
.el-menu-item.is-active{
   font-weight: 500;
}
.dark-theme .el-menu-item.is-active{
   background: #282c39  !important;
}
.hmenuCodeden-close{
    display: none;
}
.menue .el-icon-arrow-right{
    display: none;
}
.menue .el-menu-item{
    font-size: 13px;
}
.dark-theme .el-menu {
  border-right:0px solid #131417;
}
</style>



// WEBPACK FOOTER //
// src/components/menu.vue